import type { FieldMetaData } from "./fieldsMetaData";
import { createFieldMetaData } from "./createFieldMetaData";
import { findEnumObject } from "../enumutils";

export interface FlightPassengerFormState {
  flightPassengerId: number
  contact: server.dto.ContactSmallV2
  travelClass: server.dto.FlightTravelClass
  seat: string
  bookingCode: string
  meal: string
  eTicket: string
  baggage: string

  files: server.dto.File[]
}

export const mapFlightPassengerToState = (
    passenger: server.dto.FlightPassenger,
    serverReference: server.dto.ServerReference,
): FlightPassengerFormState => ({
  flightPassengerId: passenger.flightPassengerId,
  contact: passenger.contact,
  travelClass: findEnumObject(passenger.travelClass, serverReference.flightTravelClasses)!,
  seat: passenger.seat,
  bookingCode: passenger.bookingReference,
  meal: passenger.meal,
  eTicket: passenger.ticketNumber,
  baggage: passenger.baggage,
  files: passenger.files,
});

export const getUpdateFlightPassengerInstruction = (ps: FlightPassengerFormState): server.dto.UpdateFlightPassengerInstruction => ({
  baggage: ps.baggage,
  bookingReference: ps.bookingCode,
  flightPassengerId: ps.flightPassengerId,
  meal: ps.meal,
  seat: ps.seat,
  ticketNumber: ps.eTicket,
  travelClass: ps.travelClass ? ps.travelClass.value : "unknown",
});

export interface FlightPassengerFieldMetaData {
    contact: FieldMetaData;
    bookingReference: FieldMetaData;
    travelClass: FieldMetaData;
    seat: FieldMetaData;
    meal: FieldMetaData;
    ticketNumber: FieldMetaData;
    baggage: FieldMetaData;
}

export const getFlightPassengerFieldMetaData = (
    environment: server.dto.SelectedEnvironment,
    flight: server.dto.Flight, //This should probs be the shared FlightFormState object
    item: FlightPassengerFormState,
    itemPermissions: server.dto.ObjectPermissions
): FlightPassengerFieldMetaData => ({

    contact: createFieldMetaData(
        !item.contact,
        !item.contact && !itemPermissions.canModify, //Hide when empty and read-only
        !itemPermissions.canModify,
    ),

    bookingReference: createFieldMetaData(
        !item.bookingCode,
        flight.flightType !== "commercial" || (!item.bookingCode && !itemPermissions.canModify), //Hide when empty and read-only
        !itemPermissions.canModify,
    ),

    travelClass: createFieldMetaData(
        !item.travelClass || item.travelClass.value === "unknown",
        flight.flightType !== "commercial" || ((!item.travelClass || item.travelClass.value === "unknown") && !itemPermissions.canModify), //Hide when empty and read-only
        !itemPermissions.canModify,
    ),

    seat: createFieldMetaData(
        !item.seat,
        flight.flightType !== "commercial" || (!item.seat && !itemPermissions.canModify), //Hide when empty and read-only
        !itemPermissions.canModify,
    ),

    meal: createFieldMetaData(
        !item.meal,
        !item.meal && !itemPermissions.canModify, //Hide when empty and read-only
        !itemPermissions.canModify,
    ),

    ticketNumber: createFieldMetaData(
        !item.eTicket,
        flight.flightType !== "commercial" || (!item.eTicket && !itemPermissions.canModify), //Hide when empty and read-only
        !itemPermissions.canModify,
    ),

    baggage: createFieldMetaData(
        !item.baggage,
        !item.baggage && !itemPermissions.canModify, //Hide when empty and read-only
        !itemPermissions.canModify,
    ),

});
